import React from 'react';
import {labels} from '../../../../util/utils';
import styled from 'styled-components';

function MeasurementBasisMessage() {
	return (
		<StyledMeasurementBasisMessage>
			<section>{labels.MeasurementBasisMessage}</section>
			<ul>
				<li>{labels.measurementBasisProjectMappedCorrectly}</li>
				<li>{labels.measurementBasisAppropriateValue}</li>
				<li>{labels.measurementBasisAdjustValue}</li>
			</ul>
		</StyledMeasurementBasisMessage>
	);
}

export default MeasurementBasisMessage;
const StyledMeasurementBasisMessage = styled.section`
	font-size: var(--px-16);
	font-weight: 500;
	ul {
		list-style-type: disc;
		margin-left: var(--px-24);
		li {
			margin-bottom: var(--px-5);
		}
	}
`;
